<template>
  <div class="free_pay_sucess">
    <titleBar :title="title"></titleBar>
    <img src="../../assets/images/light_lesson/free_pay_success.png" />
    <p class="btn" @click="click_event">点击添加</p>
  </div>
</template>

<script>
import utils from "@/assets/js/utils";
import titleBar from "@/components/common/fit_iphonex/titleBar_fit_iphonex.vue";
export default {
  name: "free_pay_sucess",
  data() {
    return {
      title: " ",
      token: "",
      courseId: "",
      source: "",
      version: ""
    };
  },
  components: {
    titleBar
  },
  methods: {
    click_event() {
      let token = utils.getQueryString("token");
      let courseId = utils.getQueryString("courseId");
      let source = utils.getQueryString("source");
      let version = utils.getQueryString("version");
      let classNumber = utils.getQueryString("classNumber");
      let isGoToPage = utils.getQueryString("isGoToPage");
      // let path = 'pages/appPayResult/appPayResult&token='+ token +'&classNumber=' + classNumber
      let path =
        "pages/index/index&token=" +
        token +
        "&classNumber=" +
        classNumber +
        "&courseId=" +
        courseId +
        "&from=1";
      utils.sendLog(
        {
          token: token,
          version: version,
          source: source,
          extensionJson: {
            courseID: courseId
          }
        },
        "hzxx628",
        function() {
          if (parseInt(isGoToPage) == 0) {
            return;
          }
          window.location =
            "hybird://method/openCustomParamsWXMiniProgram?userName=gh_cea8850e1e83&path=" +
            path;
          // window.location = 'hybird://method/openCustomParamsWXMiniProgram?userName=gh_20524f246c0c&path=' + path
        }
      );
    }
  },
  created: function() {
    let token = utils.getQueryString("token");
    let courseId = utils.getQueryString("courseId");
    let source = utils.getQueryString("source");
    let version = utils.getQueryString("version");
    utils.sendLog(
      {
        token: token,
        version: version,
        source: source,
        extensionJson: {
          courseID: courseId
        }
      },
      "hzxx627"
    );
    window.location =
      "hybird://method/hybirdCommonNotice?noticeName=RefreshHomePageNotice";
  }
};
</script>

<style scoped lang="scss">
.free_pay_sucess {
  padding-top: 0.88rem;
  background: #fff;
  min-height: 100vh;
  img {
    width: 100%;
  }
  .btn {
    margin: auto;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0.5rem;
    width: 6.88rem;
    height: 1.26rem;
    line-height: 1.26rem;
    text-align: center;
    font-family: PingFangSC-Medium;
    font-size: 0.32rem;
    color: #ffffff;
    background: url("../../assets/images/light_lesson/buy_button.gif") 0 0 /
      cover no-repeat;
  }
}
</style>